import { Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {

  public authService = inject(AuthService);
  private rutaActiva = inject(ActivatedRoute);
  private router = inject(Router);


  public formLogin: FormGroup;
  public hide = true;
  public tipoLogueo:String = "";
  public textoInput:String = "";

  constructor() {
    if(localStorage.getItem("tipoLogueo") === '' || localStorage.getItem("tipoLogueo") === null ){
      this.router.navigateByUrl('inicio');
    }
    this.tipoLogueo = this.rutaActiva.snapshot.params.tipoLogueo;
    
    this.formLogin = new FormGroup({
      usuario: new FormControl('', [Validators.required]),
      clave: new FormControl('')
    });

    if(this.tipoLogueo === 'admin'){
      this.textoInput = "Usuario";
      this.formLogin.get("clave").setValidators(Validators.compose([Validators.required]));
      this.formLogin.get("clave").updateValueAndValidity();
    }else{
      this.textoInput = "Pin";
    }


  }

  ngOnInit(): void {
  }


  login() {
    if (this.formLogin.invalid) {
      this.formLogin.markAllAsTouched();
      return;
    }    
  
    this.authService.Login({
      clave: this.formLogin.value.clave,
      usuario: this.formLogin.value.usuario,
      idTipoUsuario: 1
    });
  }

  

}
